export default __webpack_public_path__ + "static/media/service4.9ba97f23.jpeg";